import { useTranslation } from 'react-i18next'
import { EAccountSubscriptionPlans } from 'src/types'

interface IProps {
  limit: EAccountSubscriptionPlans | undefined
}

export const usePlanLimitNotofication = () => {
  const [t] = useTranslation()

  const limitMessage = (props: IProps) => {
    if (props.limit === EAccountSubscriptionPlans.free) {
      return t('product-limit-notification.v')
    } else if (props.limit === EAccountSubscriptionPlans.plus) {
      return t('product-limit-notification-plus.v')
    } else {
      return t('product-limit-notification.v')
    }
  }
  return limitMessage
}
